// FIJA Specialist Care - Mock Data

export const heroData = {
  headline: "Heritage, Innovation, and Heart.",
  subheadline: "A new standard of luxury specialist care across London, Essex, and Kent. Where traditional hospitality meets the future of clinical excellence.",
  primaryCTA: "Book a Private Tour",
  secondaryCTA: "Download Brochure"
};

export const philosophyData = {
  headline: "A Sanctuary Designed for the Individual.",
  body: "At Fija Healthcare Specialist, we believe that moving into a care home should feel like moving into a five-star retreat. We combine the warmth of traditional luxury with pioneering AI-safety technology and a deep commitment to cultural heritage. Whether it is our residential suites or our complex mental health pathways, excellence is the only standard we accept."
};

export const featuresData = [
  {
    id: 1,
    title: "The Heritage Table",
    description: "Culturally diverse, gourmet dining tailored to your history.",
    icon: "UtensilsCrossed"
  },
  {
    id: 2,
    title: "Guardian AI",
    description: "Non-intrusive, 24/7 intelligent monitoring for total peace of mind.",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Specialist Pathways",
    description: "Expert-led care for complex mental health and dementia.",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Boutique Living",
    description: "Stately interiors designed for comfort, dignity, and elegance.",
    icon: "Crown"
  }
];

export const locationsData = [
  {
    id: 1,
    name: "London",
    tagline: "The Urban Retreat",
    description: "Bringing world-class specialist care to the heart of the capital."
  },
  {
    id: 2,
    name: "Essex",
    tagline: "The Rayleigh Sanctuary",
    description: "Nestled in the serene surroundings of Claysdon Lane, our flagship home sets the benchmark for luxury.",
    isHeadquarters: true
  },
  {
    id: 3,
    name: "Kent",
    tagline: "The Garden Estate",
    description: "Combining the tranquility of the Kent countryside with our signature high-tech care framework."
  }
];

export const specialistCareData = [
  {
    id: 1,
    title: "Residential & Nursing",
    subtitle: "The Foundation",
    description: "We provide a seamless transition from independent living to supported care. Our nursing team is hand-picked for their clinical precision and their capacity for genuine companionship."
  },
  {
    id: 2,
    title: "Dementia Care",
    subtitle: "The Expertise",
    description: "Our dementia suites are 'Memory-First' environments. We use lighting, texture, and AI-assisted safety to create a world that is easy to navigate and impossible to feel lost in."
  },
  {
    id: 3,
    title: "Complex Mental Health",
    subtitle: "The Differentiator",
    description: "Unlike traditional care homes, FIJA provides dedicated pathways for complex mental health. Our multidisciplinary team offers therapeutic support in a setting that feels like a home, not a ward."
  }
];

export const heritageTableData = {
  headline: "Flavours That Tell Your Story.",
  body: "We understand that food is identity. Our 'Heritage Table' initiative ensures that our residents enjoy authentic, culturally diverse menus—from traditional British roasts to the vibrant spices of the Commonwealth—prepared by chefs who understand the importance of home-cooked flavors.",
  image: "https://images.unsplash.com/photo-1643757343278-5d50309dfa44"
};

export const intelligentCareData = {
  headline: "Safety Without Intrusion.",
  body: "FIJA is proud to lead the industry with Guardian AI. Using subtle acoustic and motion sensors, we provide a 24/7 safety net that detects falls or changes in health patterns instantly, without the need for invasive cameras. It is the ultimate peace of mind, delivered invisibly.",
  image: "https://images.unsplash.com/photo-1758194090785-8e09b7288199"
};

export const wellnessData = {
  headline: "Wellness & Activities",
  body: "From private cinema screenings and chauffeur-driven outings to holistic therapy and intergenerational projects, life at FIJA is as vibrant as it is peaceful.",
  activities: [
    "Private Cinema Screenings",
    "Chauffeur-Driven Outings",
    "Holistic Therapy Sessions",
    "Intergenerational Projects",
    "Art & Music Therapy",
    "Garden & Nature Walks"
  ]
};

export const aboutData = {
  headline: "Setting the Standard.",
  body: [
    "FIJA Specialist Care Ltd is a specialist healthcare and social care provider committed to delivering safe, compassionate, and person-centred services that improve health, wellbeing, and quality of life. We support children, young people, adults, and older people with a wide range of healthcare and support needs through high-quality domiciliary care, supported living, residential care with personal care, and specialist health services.",
    "Our experienced team provides personalised care for individuals living with mental health conditions, learning disabilities, autism, physical disabilities, long-term health conditions, dementia, and other complex needs. We work closely with individuals, families, healthcare professionals, and local authorities to deliver holistic care that promotes independence, dignity, recovery, and positive outcomes.",
    "FIJA Specialist Care Ltd is also dedicated to advancing the healthcare workforce through professional education and international training programmes for healthcare professionals, care professionals, and aspiring care workers. Our training is designed to develop clinical knowledge, practical skills, leadership, and compassionate practice in line with UK healthcare standards and best practice.",
    "Driven by excellence, integrity, innovation, and continuous learning, FIJA Specialist Care Ltd strives to be a trusted partner in healthcare delivery, workforce development, and the provision of outstanding care that makes a lasting difference in people\u2019s lives."
  ]
};

export const careersData = {
  headline: "Join the FIJA Family",
  body: "We don't just hire staff; we recruit ambassadors of care. Join the FIJA family and help us redefine the future of the UK care industry."
};

export const contactData = {
  address: "171 High Street, Potters Bar, Hertfordshire, EN6 5BY",
  phone: "07878043849",
  email: "hello@fijahealthcarespecialist.com",
  receptionHours: "8:00 AM – 8:00 PM",
  careHours: "24/7"
};

export const navLinks = [
  { id: 1, label: "Home", href: "#home" },
  { id: 2, label: "Our Locations", href: "#locations", dropdown: ["London", "Essex", "Kent"] },
  { id: 3, label: "Specialist Care", href: "#specialist-care" },
  { id: 4, label: "The FIJA Way", href: "#fija-way" },
  { id: 5, label: "About", href: "#about" },
  { id: 6, label: "Contact", href: "#contact" }
];

export const images = {
  heroParallax: [
    "https://images.unsplash.com/photo-1505843795480-5cfb3c03f6ff",
    "https://images.unsplash.com/photo-1505843513577-22bb7d21e455"
  ],
  interiors: [
    "https://images.unsplash.com/photo-1759223198981-661cadbbff36",
    "https://images.unsplash.com/photo-1707299231603-6c0a93e0f7fa"
  ],
  bedrooms: [
    "https://images.unsplash.com/photo-1616594039964-ae9021a400a0",
    "https://images.unsplash.com/photo-1562438668-bcf0ca6578f0",
    "https://images.unsplash.com/photo-1617098900591-3f90928e8c54"
  ],
  wellness: [
    "https://images.unsplash.com/photo-1583417267826-aebc4d1542e1"
  ]
};
